import { withSvgIcon } from './withSvgIcon';

export const ArrowRightSmall = withSvgIcon(
  <path
    d="M13 17L18 12M18 12L13 7M18 12L7 12"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="square"
    strokeLinejoin="round"
  />,
  { viewBox: '0 0 24 24' },
);
